<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_as2"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('guaranteeSlip_search_button')"
          @click="funcFilter()"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('guaranteeSlip_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :footer-method="footerMethod"
      :footer-cell-class-name="footerCellClassName"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入货源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运输单号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="请输入运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="applyPolicyNo"
          title="投保单号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.applyPolicyNo"
            placeholder="请输入投保单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="policyNo"
          title="保单号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.policyNo"
            placeholder="请输入保单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="totalInsuredAmount"
          title="保额(万元)"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalInsuredAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalInsuredAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="totalActualPremium"
          title="保费(元)"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalActualPremiumStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalActualPremiumEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="insuranceBeginTime"
          title="保险起期"
          min-width="440"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.value1"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="value => changeDate(value, 'insuranceBeginTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="insuranceEndTime"
          title="保险止期"
          min-width="440"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.value2"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="value => changeDate(value, 'insuranceEndTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="投保时间"
          min-width="440"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.value3"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCreatedByName"
          title="托运人"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCreatedByName"
            placeholder="请输入托运人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="承运人实际承运人"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入承运人实际承运人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="guaranteeSlip_detail_button && scope.row.policyNo != ''"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="guaranteeSlip_getPolicyNo_button && !scope.row.policyNo"
            class="item"
            effect="dark"
            content="获取保险号"
            placement="top"
          >
            <vxe-button type="text" @click="funcGetPolicyNo(scope.row.code)">
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  components: {},
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      detailFlag: false,
      exportObj: {
        exportUrl: "/ntocc-basic-api/openInsure/exportInsure", //导出接口
        name: "保单"
      },
      listQuery: {
        value1: "",
        value2: "",
        value3: "",
        mainOrderNumber: "", //货源单号
        orderDetailNumber: "", //运输单号
        vehicleLicense: "", //车牌号
        driverName: "", //承运人实际承运人
        shipmentCode: "", //托运人
        insuranceEndTimeStart: "", //保险止期
        insuranceEndTimeEnd: "", //保险止期
        insuranceBeginTimeStart: "", //保险起期
        insuranceBeginTimeEnd: "", //保险起期
        totalActualPremium: "", //保费
        totalInsuredAmount: "", //保额
        applyPolicyNo: "", //保单号
        pageNum: 1,
        pageSize: 20,
        total: 0,
        sortField: "",
        sortType: "",
        orderCreatedByName: ""
      },
      guaranteeSlip_detail_button: false,
      guaranteeSlip_getPolicyNo_button: false
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    }
  },
  created() {
    this.guaranteeSlip_detail_button = this.getLimit(
      "guaranteeSlip_detail_button"
    );
    this.guaranteeSlip_getPolicyNo_button = this.getLimit(
      "guaranteeSlip_getPolicyNo_button"
    );
    this.findList();
  },
  methods: {
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/openInsure",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 获取详情
    funcDetail(code) {
      return request({
        url: "/ntocc-basic-api/openInsure/" + code,
        method: "get"
      }).then(response => {
        if (response.status == 0) {
          window.open(response.data);
        } else {
          this.$message.error("获取详情失败");
        }
      });
      // window.open('http://third-image.oss-cn-hangzhou.aliyuncs.com/ea8d3fb4aee347a09e8d9cc4271c29ae.pdf')
      // this.detailFlag = true
      // this.$refs.detailRef.getContract(code)
    },
    // 获取保单号
    funcGetPolicyNo(code) {
      return request({
        url: "/ntocc-basic-api/openInsure/getPolicyNo",
        method: "put",
        params: { code: code }
      }).then(response => {
        this.findList();
      });
    },
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return "col-blue";
        } else {
          return "col-red";
        }
      }
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "平均";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.mean(data, column.property);
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "和值";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>

<style></style>
